import { I18n } from 'react-redux-i18n';

function statusTracking(status) {
  if (status) {
    switch (status) {
      case 1:
        return I18n.t('BEE2262' /* Iniciado */);
      case 2:
        return I18n.t('BEE1833' /* Finalizado */);
      default:
        return status;
    }
  } else if (!status) {
    return [
      { value: 1, label: I18n.t('BEE2262' /* Iniciado */) },
      { value: 2, label: I18n.t('BEE1833' /* Finalizado */) },
    ];
  }
}

function typeTracking(type) {
  if (type) {
    switch (type) {
      case 'production':
        return I18n.t('BEE2770' /* Ordem de Produção */);
      case 'indirect':
        return I18n.t('BEE4277' /* Tarefa Indireta */);
      default:
        return type;
    }
  } else if (!type) {
    return [
      { value: 'production', label: I18n.t('BEE2770' /* Ordem de Produção */) },
      { value: 'indirect', label: I18n.t('BEE4277' /* Tarefa Indireta */) },
    ];
  }
}

export default {
  statusTracking,
  typeTracking,
};
